import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import {
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  EditOutlined,
  FileExcelOutlined,
  MinusCircleOutlined,
  MoreOutlined,
  SyncOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Typography,
  Card,
  Select,
  Input,
  Radio,
  Button,
  Space,
  Form,
  Table,
  Tooltip,
  Tag,
  Menu,
  Dropdown,
  Modal,
  notification,
  DatePicker,
  Popover,
  Checkbox,
  InputNumber,
} from "antd";
import "../Pages/CSS/Traitement.css";
import { SpecialitesService } from "../Services/SpecialitesService";
import { JournalCentralService } from "../Services/JournalCentralService";
import { ReglementsService } from "../Services/ReglementsService";
import dayjs from "dayjs";
import moment from "moment";

const { Option } = Select;

const ReglementsDivers = () => {
  const initialTableData = [];
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [specialites, setSpecialites] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOption, setSelectedOption] = useState("NP");
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [years, setYears] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [typeReglementFourn, setTypeReglementFourn] = useState([]);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paramsDetails, setParamsDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [journalBqueData, setJournalBqueData] = useState([]);
  const [journalRegData, setJournalRegData] = useState([]);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isRgFactEnabled, setIsRgFactEnabled] = useState(false);
  const [isComptaEnabled, setIsComptaEnabled] = useState(false);
  const [isAnRegEnabled, setIsAnRegEnabled] = useState(false);
  const [isAnPayeEnabled, setIsAnPayeEnabled] = useState(false);
  const [isPayingEnabled, setIsPayingEnabled] = useState(false);
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [isOtherButtonsEnabled, setIsOtherButtonsEnabled] = useState(false);
  const [isMassTransferEnabled, setIsMassTransferEnabled] = useState(false);
  const [isAcompteChecked, setIsAcompteChecked] = useState(false);
  const [montantReglement, setMontantReglement] = useState(
    modalData?.montant_reglmt || modalData?.freel || 0
  );
  const [selectedTypeReglement, setSelectedTypeReglement] = useState(null);
  const [solde, setSolde] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAnnulationModalOpen, setIsAnnulationModalOpen] = useState(false);
  const [annulationPreviewData, setAnnulationPreviewData] = useState([]);

  const [form] = Form.useForm();

  const specialitesService = new SpecialitesService();
  const journalCentralService = new JournalCentralService();
  const reglementService = new ReglementsService();

  const fetchYears = async () => {
    try {
      const yearsData = await reglementService.getReg();
      console.log("Années récupérées :", yearsData); // Vérifiez la structure des données
      setYears(yearsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };


  const fetchReglementations = async () => {
    if (selectedYear && selectedOption) {
      setLoading(true);
      try {
        const data = await reglementService.getReglementationDivers(selectedYear, selectedOption);
        // Filtrer ici si nécessaire, ou s'assurer que le service API renvoie déjà les données filtrées
        setTableData(data);
        setFilteredData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setLoading(false);
      }
    }

  };

  useEffect(() => {
    fetchYears();
  }, []);

  useEffect(() => {
    fetchReglementations();
  }, [selectedYear, selectedOption]);

  useEffect(() => {
    const total = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.montfact || 0),
      0
    );
    setTotalAmount(total);
    setRowCount(filteredData.length);
  }, [filteredData]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  useEffect(() => {
    if (specialites.length === 0) {
      specialitesService
        .getAllSpecialites()
        .then((data) => {
          setSpecialites(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, [specialitesService, specialites.length]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const fetchJournalBque = async () => {
    try {
      const journalData = await journalCentralService.getAllJournaux();
      setJournalBqueData(journalData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  // Charge les paramètres au montage du composant
  const loadParams = async () => {
    try {
      const data = await reglementService.getParamReg();
      setParamsDetails(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données", error);
    }
  };
  useEffect(() => {
    loadParams();
  }, []);

  useEffect(() => {
    if (paramsDetails && paramsDetails.datedeb) {
      setSelectedDate(dayjs(paramsDetails.datedeb));
    } else {
      setSelectedDate(dayjs());
    }
  }, [paramsDetails]);

  const handleTypeReglementChange = (value) => {
    setSelectedTypeReglement(value);
  };
  const typeReglementLabels = {
    V: "Virement",
    C: "Chèque",
    Compte: "Compte Avance",
    E: "Espèce",
    T: "Transfert",
  };
  useEffect(() => {
    form.setFieldsValue({
      datetrait: selectedDate.format("MMM-YYYY"),
    });
  }, [selectedDate, form]);

  useEffect(() => {
    setMontantReglement(modalData?.montant_reglmt || modalData?.freel || 0);
  }, [modalData]);

  const handleAcompteChange = (e) => {
    const isChecked = e.target.checked;
    setIsAcompteChecked(isChecked);
    if (isChecked) {
      setMontantReglement(0);
    } else {
      setMontantReglement(modalData?.montant_reglmt || modalData?.freel || 0);
    }
  };

  const handleMontantReglementChange = (value) => {
    setMontantReglement(value);
  };
  const formatNumberWithSeparator = (number) => {
    // Convertit en nombre au cas où l'entrée n'est pas déjà un nombre
    const num = Number(number);
    return num.toLocaleString("fr-FR"); // Utilisez 'fr-FR' ou une autre locale appropriée
  };

  const getConditionalColumns = () => {
    if (selectedOption === "PP" || selectedOption === "CC") {
      return [
        {
          title: "M.P",
          dataIndex: "typereglmt",
          key: "typereglmt",
          align: "center",
          sorter: (a, b) => a.typereglmt.localeCompare(b.typereglmt),
          render: (typereglmt) => {
            let color = "";
            let text = "";

            if (typereglmt === "C") {
              color = "#02b4f0";
              text = "C";
            } else if (typereglmt === "P") {
              color = "#02b4f0";
              text = "P";
            } else if (typereglmt === "T") {
              color = "#02b4f0";
              text = "T";
            }
            else if (typereglmt === "V") {
              color = "#02b4f0";
              text = "V";
            }
            else if (typereglmt === "E") {
              color = "#02b4f0";
              text = "E";
            }
            return (
              <div style={{ paddingLeft: 10 }}>
                <Tag color={color} key={typereglmt}>
                  {text}
                </Tag>
              </div>
            );
          },
        },

        {
          title: "Date Reg.",
          dataIndex: "datetrait",
          key: "datetrait",
          align: "center",
          sorter: (a, b) => a.datetrait.localeCompare(b.datetrait),
          render: (text, record) => (
            <div
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            >
              {moment(text).locale("fr").format("DD/MM/YYYY")}
            </div>
          ),
        },
        {
          title: "N° C/V",
          dataIndex: "compte",
          key: "compte",
          align: "center",
          sorter: (a, b) => a.compte.localeCompare(b.compte),
        },
        {
          title: "Bque.",
          dataIndex: "codebque",
          key: "codebque",
          align: "center",
          sorter: (a, b) => a.codebque.localeCompare(b.codebque),
        },
      ];
    } else {
      return [];
    }
  };

  const baseColumns = [
    {
      title: "N° F.", dataIndex: "numenreg", key: "numenreg", align: "center",
      //   sorter: (a, b) => a.numenreg.localeCompare(b.numenreg),

    },
    {
      title: "N° F. Frs",
      dataIndex: "numfact",
      key: "numfact",
      align: "center",
      sorter: (a, b) => a.numfact.localeCompare(b.numfact),
    },
    {
      title: "Date fact.",
      dataIndex: "datefact",
      key: "datefact",
      align: "center",
      sorter: (a, b) => a.datefact.localeCompare(b.datefact),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: "Date recep.",
      dataIndex: "daterecep",
      key: "daterecep",
      align: "center",
      sorter: (a, b) => a.daterecep.localeCompare(b.daterecep),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
    ...(selectedOption !== "PP" && selectedOption !== "CC"
      ? [
        {
          title: "J retard.",
          dataIndex: "nbjours",
          key: "nbjours",
          align: "center",
          sorter: (a, b) => a.nbjours.localeCompare(b.nbjours),

        },
      ]
      : []),
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Montant
        </div>
      ),
      dataIndex: "montfact",
      key: "montfact",
      align: "right",
      sorter: (a, b) => a.montfact.localeCompare(b.montfact),
      render: (text) => {
        const amount = parseFloat(text);
        const color = amount < 0 ? "red" : ""; // Colorie en rouge si le montant est négatif
        return (
          <div style={{ paddingRight: 10, color: color }}>
            {formatNumberWithSeparator(text && amount !== 0 ? amount : "")}
          </div>
        );
      },
    },
    {
      title: "N° Frs",
      dataIndex: "numfourn",
      key: "numfourn",
      align: "center",
      sorter: (a, b) => a.numfourn.localeCompare(b.numfourn),

    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Fournisseurs
        </div>
      ),
      dataIndex: "intitule",
      key: "intitule",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>{text}</div>
      ),
      sorter: (a, b) => a.intitule.localeCompare(b.intitule),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: 5,
          }}
        >
          Spécialité
        </div>
      ),

      dataIndex: "nature_fact",
      key: "nature_fact",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left", paddingRight: 5, paddingLeft: 5 }}>{text}</div>
      ),
      sorter: (a, b) => a.nature_fact.localeCompare(b.nature_fact),
    },
    {
      title: "Mois Trait.",
      dataIndex: "date_process",
      key: "date_process",
      sorter: (a, b) => a.date_process.localeCompare(b.date_process),
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
    },
  ];

  const conditionalColumns = getConditionalColumns();
  baseColumns.push(...conditionalColumns);

  baseColumns.push({
    title: "État",
    dataIndex: "etape",
    key: "etape",
    className: "small-cell",
    ellipsis: true,
    align: "center",
    sorter: (a, b) => a.etape.localeCompare(b.etape),
    render: (etape) => {
      let color = "";
      let text = "";
      switch (etape) {
        case "NP":
          color = "#b51804";
          text = "Non Échue";
          break;
        case "AP":
          color = "#e39c02";
          text = "Échue";
          break;
        case "CC":
          color = "#059e23";
          text = "Compt.";
          break;
        case "PP":
          color = "#11d938";
          text = "Payée.";
          break;
        case "NN":
          color = "#d61204";
          text = "Annulée.";
          break;
      }
      return (
        <div style={{ paddingLeft: 10 }}>
          <Tag color={color} key={etape}>
            {text}
          </Tag>
        </div>
      );
    },
  });

  const actionColumn = {
    title: (
      <div
        style={{ backgroundColor: "#010f1c", color: "white", padding: "1px" }}
      ></div>
    ),
    dataIndex: "actions",
    key: "actions",
    align: "center",
    fixed: "right",
    render: (text, record) => (
      <Space size="small">
        <Tooltip title="Modifier règlement">
          <EditOutlined
            style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
            onClick={() => openEditModal(record)}

          />
        </Tooltip>
        <Tooltip title="Annuler règlement">
          <MinusCircleOutlined
            style={{ cursor: "pointer", color: "#67f02e", marginRight: 8 }}
            onClick={() => handleCancelReglement(record)}
          />
        </Tooltip>
      </Space>
    ),
  };

  if (selectedOption === "PP") {
    baseColumns.push(actionColumn);
  }

  const columns = baseColumns;

  const fetchSaisie = async (type) => {
    try {
      const journalsData = await reglementService.getSaisieReg();
      setJournalRegData(journalsData);
      setTypeReglementFourn(
        journalsData.filter((journal) => journal.type === type)
      );
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des journaux comptables",
        description: error.message,
      });
    }
  };

  const openModal = (type) => {
    if (selectedRowKeys.length === 1) {
      const selectedRecord = tableData.find(
        (record) => record.numenreg === selectedRowKeys[0]
      );
      setModalData({ ...selectedRecord, type });
      setModalVisible(true);
      loadParams();
      fetchSaisie();
    } else {
      // Gérer le cas où aucune ligne ou plusieurs lignes sont sélectionnées
      alert("Veuillez sélectionner une seule ligne.");
    }
  };

  const openEditModal = (record) => {
    setIsEditMode(true); // Mode modification
    setModalData(record);
    setModalVisible(true);
    loadParams();
    fetchSaisie();

    // Initialiser les champs typeReg et numReg
    form.setFieldsValue({
      typeReg: record.typereglmt,
      numReg: record.numreglmt,
      comptegen: record.comptegen
    });
  };


  const handleModalCancel = () => {
    setModalVisible(false);
    setModalData(null);
    setSelectedTypeReglement(null);
    form.resetFields(['typeReg', 'numReg', 'comptegen']);
    setSolde(0)
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      const selectedJournal = journalRegData.find(journal => journal.compte_rattache === values.comptegen);

      const payload = {
        codeBque: selectedJournal ? selectedJournal.codej : null,
        comptegen: values.comptegen,
        dateReg: values.dateReg.toISOString(),
        datecompta: values.dateReg.toISOString(),
        datetrait: selectedDate.toISOString(),
        libReg: values.libReg,
        listFactures: selectedRowKeys.map((key) =>
          tableData.find((item) => item.numenreg === key)
        ),
        montantReg: montantReglement,
        numReg: values.numReg,
        typeReg: values.typeReg
      };

      await reglementService.updateSaisieReg(payload);
      notification.success({ message: 'Règlement enregistré avec succès' });
      // Réinitialisation des champs
      form.resetFields(['typeReg', 'numReg', 'comptegen']);
      setSelectedTypeReglement(null);
      setSolde(0)

      setModalVisible(false);
      setModalData(null);
      fetchReglementations();
    } catch (error) {
      notification.error({ message: 'Erreur lors de l\'enregistrement du règlement' });
      console.error('Erreur lors de l\'enregistrement du règlement :', error);
    }
  }
  const handleApayerReglement = async (record) => {
    try {
      const payload = selectedRowKeys.map(
        (key) => tableData.find((item) => item.numenreg === key).numenreg
      );
      await reglementService.apayerReglementFact(payload);
      notification.success({ message: 'Règlement annulé avec succès' });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({ message: 'Erreur lors de l\'annulation du règlement' });
      console.error('Erreur lors de l\'annulation du règlement :', error);
    }
  };

  const annulerApayerReglement = async (record) => {
    try {
      const payload = selectedRowKeys.map(
        (key) => tableData.find((item) => item.numenreg === key).numenreg
      );
      await reglementService.annulerApayerReglementFact(payload);
      notification.success({ message: 'Règlement annulé avec succès' });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({ message: 'Erreur lors de l\'annulation du règlement' });
      console.error('Erreur lors de l\'annulation du règlement :', error);
    }
  };
  const handleValidCompta = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      const payload = {
        comptas: comptaPreviewData,
        factures: selectedRows,
      };
      const data = await reglementService.addValidComptaReg(payload);
      setIsModalOpen(false);
      fetchReglementations();
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };
  const handleAnnulationComptabilisation = async (record) => {
    try {

      const payload = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      const data = await reglementService.previewAnnulationComptaReg(
        payload
      );
      setAnnulationPreviewData(data);
      setIsAnnulationModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données d'annulation :",
        error
      );
    }
  };

  const handleValidAnnulationCompta = async () => {
    try {
      // Payload pour addAnnulationCompta
      const addPayload = annulationPreviewData;

      // Payload pour putAnnulationCompta
      const putPayload = annulationPreviewData.map((item) => item.numfactipm);

      await reglementService.addPreviewAnnulationComptaReg(addPayload);
      await reglementService.updateAnnulationCompta(putPayload);
      fetchReglementations();

      setIsAnnulationModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la validation de l'annulation de la comptabilisation :",
        error
      );
    }
  };

  const handleCancelReglement = async (record) => {
    try {
      const payload = {
        ...record
      };
      await reglementService.cancelSaisieReg(payload);
      notification.success({ message: 'Règlement annulé avec succès' });
      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({ message: 'Erreur lors de l\'annulation du règlement' });
      console.error('Erreur lors de l\'annulation du règlement :', error);
    }
  };
  const handleRefresh = async () => {
    try {

      fetchReglementations(); // Rafraîchissez les données après l'annulation
    } catch (error) {
      notification.error({ message: 'Erreur lors de l\'annulation du règlement' });
      console.error('Erreur lors de l\'annulation du règlement :', error);
    }
  };

  const gestionMenu1 = (
    <Menu>
      <Menu.Item icon={<SyncOutlined />} onClick={handleRefresh} key="1">
        Actualiser
      </Menu.Item>
      <Menu.Item
        icon={<CheckCircleOutlined />}
        disabled={!isPayingEnabled}
        key="2"
        onClick={handleApayerReglement}
      >
        A payer
      </Menu.Item>
      <Menu.Item icon={<UndoOutlined />} disabled={!isAnPayeEnabled} onClick={annulerApayerReglement} key="3">
        Annuler A payer
      </Menu.Item>

    </Menu>
  );

  const stateConfig = {
    NP: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: false,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    AP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: true,
      isAnRegEnabled: false,
      isRgFactEnabled: true,
      isOtherButtonsEnabled: true,
    },
    PP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: true,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    CC: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: true,
      isRgFactEnabled: false,
    },
    NN: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
  };

  const handleOptionChange = (e) => {
    const newOption = e.target.value;
    setSelectedOption(newOption);
    setSelectedRowKeys([]); // Réinitialiser la sélection des lignes
    setIsEditingEnabled(false);
    setIsPayingEnabled(false);
    setIsMassTransferEnabled(false);
    setIsComptaEnabled(false);
    setIsAnPayeEnabled(false);
    setIsAnRegEnabled(false);
    setIsRgFactEnabled(false);
    setIsOtherButtonsEnabled(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);

    const hasSelectedRows = newSelectedRowKeys.length > 0;
    if (hasSelectedRows) {
      const selectedState = stateConfig[selectedOption] || {};
      setIsEditingEnabled(selectedState.isEditingEnabled);
      setIsPayingEnabled(selectedState.isPayingEnabled);
      setIsMassTransferEnabled(selectedState.isMassTransferEnabled);
      setIsComptaEnabled(selectedState.isComptaEnabled);
      setIsAnPayeEnabled(selectedState.isAnPayeEnabled);
      setIsAnRegEnabled(selectedState.isAnRegEnabled);
      setIsRgFactEnabled(selectedState.isRgFactEnabled);
      setIsOtherButtonsEnabled(selectedState.isOtherButtonsEnabled);
    } else {
      setIsEditingEnabled(false);
      setIsPayingEnabled(false);
      setIsMassTransferEnabled(false);
      setIsComptaEnabled(false);
      setIsAnPayeEnabled(false);
      setIsAnRegEnabled(false);
      setIsRgFactEnabled(false);
      setIsOtherButtonsEnabled(false);
    }
  };

  const handlePrintClick = () => {
    fetchJournalBque();
    setIsPrintModalVisible(true);
  };

  const handlePrintModalOk = async () => {
    let docName = "ListeFactAPayer";
    const payload = selectedRowKeys;

    try {
      await journalCentralService.updatePrint(payload);

      switch (selectedReportType) {
        case "ListeFactAPayer":
          journalCentralService.printAPService(docName);
          break;
        case "FactureNonPayees":
          journalCentralService.printNPService(docName);
          break;
        case "Lettre_Cheque_Fourn_Div":
          docName = "Lettre_Cheque_Fourn_Div";
          journalCentralService.printChequeService(docName);
          break;
        case "Ordre_Virement_Fourn_Div":
          docName = "Ordre_Virement_Fourn_Div";
          journalCentralService.printVirementService(docName);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour des données :", error);
    }
  };

  const handlePrintModalCancel = () => {
    setIsPrintModalVisible(false);
    setSelectedReportType(null);
    form.resetFields();
  };

  const handleExportToExcel = async () => {
    console.log("handleExportToExcel called");
    const payload = selectedRowKeys;
    try {
      console.log("Payload:", payload);
      await journalCentralService.updatePrint(payload);
      console.log("Print updated");
      await journalCentralService.exportVirementMasse(selectedRowKeys);
      console.log("Export successful");
    } catch (error) {
      console.error("Erreur lors de l'exportation :", error);
    }
  };

  const handleCompteRattacheChange = async (value) => {
    try {
      const soldeData = await reglementService.getSoldeReg(value);
      setSolde(soldeData);
    } catch (error) {
      console.error("Erreur lors de la récupération du solde :", error);
    }
  };



  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => a.codej.localeCompare(b.codej),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
      sorter: (a, b) => a.datecompta.localeCompare(b.datecompta),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      render: (text, record) => (
        <div
          style={{
            whiteSpace: "nowrap",
            textAlign: "center",
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {moment(text).locale("fr").format("DD/MM/YYYY")}
        </div>
      ),
      sorter: (a, b) => a.datetrait.localeCompare(b.datetrait),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => a.numpiece.localeCompare(b.numpiece),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => a.numcheque.localeCompare(b.numcheque),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => a.numfactipm.localeCompare(b.numfactipm),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => a.comptegen.localeCompare(b.comptegen),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => a.comptetiers.localeCompare(b.comptetiers),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => a.libelle.localeCompare(b.libelle),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumberWithSeparator(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => a.debit.localeCompare(b.debit),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumberWithSeparator(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => a.credit.localeCompare(b.credit),
    },
  ];
  const totalDebit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit = annulationPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde0 = totalDebit - totalCredit;

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleComptabiliser = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );

      console.log("Selected Rows: ", selectedRows); // Debugging line

      const data = await reglementService.ComptaRegPreviewCompta(selectedRows);
      console.log("Compta Preview Data: ", data); // Debugging line

      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };



  return (
    <div>
      <b>
        {rowCount} Facture(s) - {formatNumberWithSeparator(totalAmount)}{" "}
      </b>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={24}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={10} lg={10} style={{ display: "flex" }}>
              <Row gutter={8}>
                <Col xs={24}>
                  <Space direction="vertical" style={{ textAlign: "left" }}>
                    <label style={{ fontSize: 12 }}>Exercice</label>
                    <Select
                      bordered={false}
                      style={{
                        borderBottom: "2px solid #030303",
                        width: "80px",
                      }}
                      onChange={handleYearChange}
                      value={selectedYear}
                    >

                      {years.map((year) => (
                        <Option key={year} value={year}>
                          {year}
                        </Option>
                      ))}
                    </Select>
                  </Space>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={14} lg={14}>
              <Row justify="end">
                <Col span={24} style={{ textAlign: "right" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: "1rem" }}>
                    {[
                      { value: "TT", label: "Tout" },
                      { value: "NP", label: "Non Échue" },
                      { value: "AP", label: "Échue" },
                      { value: "PP", label: "Réglée" },
                      { value: "CC", label: "Comptabilisée" },
                    ].map((item) => (
                      <button
                        key={item.value}
                        onClick={() => handleOptionChange({ target: { value: item.value } })}
                        style={{
                          padding: "6px 14px",
                          borderRadius: 20,
                          border: "none",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 500,
                          transition: "all 0.3s ease",
                          background: selectedOption === item.value
                            ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                            : "#f0f0f0",
                          color: selectedOption === item.value ? "#fff" : "#595959",
                          boxShadow: selectedOption === item.value
                            ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                            : "0 1px 3px rgba(0, 0, 0, 0.1)",
                        }}
                        onMouseEnter={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#e0e0e0";
                            e.currentTarget.style.transform = "translateY(-1px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedOption !== item.value) {
                            e.currentTarget.style.background = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                          }
                        }}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </Col>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >

                    <Button
                      icon={<MoreOutlined />}
                      className="buttonEdition"
                      disabled={!isEditingEnabled}
                      onClick={handlePrintClick}
                    >
                      Édition
                    </Button>

                    <Button
                      className="buttonRegle"
                      disabled={!isRgFactEnabled}
                      onClick={openModal}
                    >
                      Régler Facture(s)
                    </Button>

                    <Button
                      icon={<CalculatorOutlined />}
                      className="buttonCompta"
                      disabled={!isComptaEnabled}
                      onClick={handleComptabiliser}
                    >
                      Comptabiliser
                    </Button>
                    <Dropdown overlay={gestionMenu1} trigger={["click"]}>
                      <Button
                        icon={<MoreOutlined />}
                        disabled={!isOtherButtonsEnabled}
                      />
                    </Dropdown>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
          <Input
            placeholder="Recherche..."
            bordered={false}
            style={{ borderBottom: "1px solid black", width: "25%" }}
            onChange={(e) => handleSearch(e.target.value)}
            onPressEnter={(e) => handleSearch(e.target.value)}
          />
          <Card bordered={false}>
            <Table
              loading={loading}
              rowSelection={{
                selectedRowKeys,
                onChange: onSelectChange,
              }}
              rowKey={(record) => record.numenreg}
              scroll={{ x: true }}
              className="custom-header2-table"
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              bordered
              showSorterTooltip={false}
              pagination={{ pageSize: 5 }}
              columns={columns}
              dataSource={filteredData}
              rowClassName={(record) =>
                selectedRowKeys.includes(record.numenreg) ? "selected-row" : ""
              }
            />
          </Card>
        </Col>
      </Row>
      <Modal
        title={isEditMode ? "Modification Règlement Facture Fournisseur de Soins" : "Règlement Facture Fournisseur de Soins"}
        open={modalVisible}
        maskClosable={false}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
        style={{ top: 20 }}
        width={1000}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="typeReg"
                label="Type Règlement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  placeholder="- Sélectionner -"
                  onChange={handleTypeReglementChange}
                >
                  <Option value="V">Virement</Option>
                  <Option value="C">Chèque</Option>
                  <Option value="Compte">Compte Avance</Option>
                  <Option value="E">Espèce</Option>
                  <Option value="T">Transfert</Option>
                </Select>
              </Form.Item>
            </Col>
            {(selectedTypeReglement === "V" || selectedTypeReglement === "C") && (
              <Form.Item name="comptegen" label="Banque"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}>
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.codej === "B1")
                      .map((journal) => (
                        <Option
                          key={journal.compte_rattache}
                          value={journal.compte_rattache}
                        >
                          {` ${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
            {selectedTypeReglement === "Compte" && (
              <Form.Item label="Compte Avance"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}>
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.codej === "")
                      .map((journal) => (
                        <Option key={journal.codej} value={journal.codej}>
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
            {selectedTypeReglement === "T" && (
              <Form.Item label="Transfert" name="comptegen"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}>
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.codej === "OM")
                      .map((journal) => (
                        <Option
                          key={journal.compte_rattache}
                          value={journal.compte_rattache}
                        >
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}

            <Col span={6}>
              <Form.Item
                name="numReg"
                label={`N° ${selectedTypeReglement
                    ? typeReglementLabels[selectedTypeReglement]
                    : ""
                  }`}
                rules={[
                  { required: true, message: "Numéro de facture requis" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="dateReg"
                label="Date Règlement"
                initialValue={dayjs()}
                rules={[
                  { required: true, message: "Date de règlement requise" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Row gutter={16}>
                <Col span={20}>
                  <Form.Item name="datetrait" label="Date traitement">
                    <Input
                      value={selectedDate}
                      style={{ width: "100%" }}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <div style={{ paddingTop: "30px" }}>
                    <Popover
                      placement="bottomCenter"
                      content={
                        <DatePicker
                          format="MMM-YYYY"
                          value={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                      }
                      trigger="click"
                    >
                      <Button icon={<CalendarOutlined />} />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  paddingTop: "8px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Space>
                  Facture N° {modalData?.numfact}
                  <Checkbox
                    checked={isAcompteChecked}
                    onChange={handleAcompteChange}
                  >
                    Acompte
                  </Checkbox>
                </Space>
                {!isEditMode && (
                  <span>
                    Solde: <strong color="#59e60e">{solde.solde || 0}</strong>
                  </span>
                )}
              </div>
              <Form.Item>
                <InputNumber
                  value={montantReglement}
                  disabled={!isAcompteChecked}
                  onChange={handleMontantReglementChange}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          {!isEditMode && (
            <>
              <Row gutter={16}>
                <Col span={24}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <span>
                      Montant(s) {modalData?.numfactures} facture(s):{" "}
                      {modalData?.montfact}
                    </span>
                    <span>Montant Réglé: {montantReglement}</span>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="libReg"
                    label="Libellé"
                    rules={[
                      { required: true, message: "Veuillez entrer un libellé" },
                    ]}
                    initialValue={`RGLMT Facture N° ${modalData?.numenreg} / ${modalData?.raisoc}`}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form>
      </Modal>


      <Modal
        title="Edition"
        open={isPrintModalVisible}
        onOk={handlePrintModalOk}
        onCancel={handlePrintModalCancel}
        width={800}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handlePrintModalCancel}>
            Fermer
          </Button>,
          <Button key="submit" type="primary" onClick={handlePrintModalOk}>
            Imprimer
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="edition" label="Edition">
            <Select
              bordered={false}
              style={{ borderBottom: "1px solid black" }}
              onChange={setSelectedReportType}
            >
              <Option value="ListeFactAPayer">Facture à Payer</Option>
              <Option value="FactureNonPayees">Facture non Payées</Option>
              <Option value="Lettre_Cheque_Fourn_Div">Lettre Chèque</Option>
              <Option value="Ordre_Virement_Fourn_Div">Ordre de Virement</Option>
            </Select>
          </Form.Item>
          {(selectedReportType === "Lettre_Cheque_Fourn_Div" ||
            selectedReportType === "Ordre_Virement_Fourn_Div") && (
              <Form.Item label="Banque">
                <Select
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303", width: "100%" }}
                >
                  {journalBqueData &&
                    journalBqueData
                      .filter((journal) => journal.codej === "B1")
                      .map((journal) => (
                        <Option key={journal.codej} value={journal.codej}>
                          {`${journal.codej} - ${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
        </Form>
      </Modal>

      <Modal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(comptaPreviewData),
                "Aperçu Ecriture au Journal.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
            // y: "240px",
          }}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumberWithSeparator(totalDebit1)}</strong>
                <strong>Total Crédit : {formatNumberWithSeparator(totalCredit1)}</strong>
                <strong> Solde : {formatNumberWithSeparator(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </Modal>
      <Modal
        title="Annulation Comptabilisation"
        open={isAnnulationModalOpen}
        onCancel={() => setIsAnnulationModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsAnnulationModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            disabled={solde !== 0}
            onClick={handleValidAnnulationCompta}
          >
            Valider
          </Button>,
        ]}
        width={1500}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          pagination={false}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          scroll={{
            x: true,

          }}
          showSorterTooltip={false}
          dataSource={annulationPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumberWithSeparator(totalDebit)}</strong>

                <strong>Total Crédit : {formatNumberWithSeparator(totalCredit)}</strong>

                <strong> Solde : {formatNumberWithSeparator(solde0)}</strong>
              </Space>
            </div>
          )}
        />
      </Modal>
    </div>
  );
};

export default ReglementsDivers;
